export default __webpack_public_path__ + "static/media/prevArrow.adfb6a65.svg";